import { Injectable } from '@angular/core';
import { RealStateFilterFeatures } from '@app-model/promotedContent';
import { RealEstateService } from '@app-services/realEstate.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RealEstateFeaturesOptionsService {
	constructor(private readonly realEstateService: RealEstateService) { }

	searchFeatures(entityType: string, entityId: string, searchTerm: string = ''): Observable<RealStateFilterFeatures[]> {
		const trimmed = searchTerm.trim();
		return this.realEstateService
			.getFilterFeatures(
				entityType,
				entityId,
				{
					page: 0,
					pageSize: 50,
					sortDirection: 'ASC',
					sortField: 'label'
				},
				trimmed || undefined
			)
			.pipe(map(response => response?.data ?? []));
	}

	searchFeaturesByCardholder(searchTerm: string = '', slugs: string[] = []): Observable<RealStateFilterFeatures[]> {
		const trimmed = searchTerm.trim();
		return this.realEstateService
			.getFilterFeaturesByCardholder(
				{
					page: 0,
					pageSize: 50,
					sortDirection: 'ASC',
					sortField: 'label'
				},
				trimmed || undefined,
				slugs
			)
			.pipe(map(response => response?.data ?? []));
	}
}
